import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonNewModule } from '../../common/button-new/button-new.module';
import { IconModule } from '../../common/icon/icon.module';
import { TagModule } from '../../common/tag/tag.module';
import { ButtonModule } from './../../common/button/button.module';
import { DividerModule } from './../../common/divider/divider.module';
import { GroupModule } from './../../common/group/group.module';
import { LabelModule } from './../../common/label/label.module';
import { DialogHeaderModule } from './../../dialog/dialog-header/dialog-header.module';
import { CheckboxModule } from './../../forms/checkbox/checkbox.module';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@NgModule({
  declarations: [ConfirmDialogComponent],
  exports: [ConfirmDialogComponent],
  imports: [
    DialogHeaderModule,
    CommonModule,
    GroupModule,
    LabelModule,
    DividerModule,
    ButtonModule,
    CheckboxModule,
    TagModule,
    IconModule,
    ButtonNewModule,
  ],
})
export class ConfirmDialogModule {}
export { ConfirmDialogComponent } from './confirm-dialog.component';
